import { http } from "../services/config-winfit-core";

export const sendMessages = async (messageData) => {
  const { data } = await http.post("websocket/message_winfit", messageData);
  return data;
};
